export default String.raw`
.blog-item {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 3px;

    &__title {
        margin: 16px 0;
        word-wrap: break-word;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        color: $primaryColorFont;
    }

    &__img {
        margin-left: auto;
        margin-right: auto;
        aspect-ratio: 13 / 9;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        img {
            object-fit: cover;
            max-width: 100%;
            max-height: 100%;
            border-radius: 8px;
        }
    }

    &__content {
        height: 3lh;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        color: $primaryColorFont;
        width: 100%;
        margin: 0 0 16px 0;
    }

    &__read {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        width: 100%;
        @include body-2-regular;

        &-top {
            display: flex;
            align-items: center;
            column-gap: 1em;
            width: 100%;
            time {
                color: $bgColorFont;
                white-space: nowrap;
            }
            &-tags {
                word-wrap: break-word;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
                padding: 3px;
            }
        }

        &-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            &-time {
                color: $bgColorFont;
            }

            &-button {
                @include button;
                white-space: nowrap;
                display: flex;
                justify-content: end;
                a {
                    display: flex;
                    align-items: center;
                    svg {
                        width: 14px;
                        height: 14px;
                        margin-left: 0.8em;
                    }
                }
            }
        }
    }
}
`